import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { FuseResultMatch } from "fuse.js";

@Pipe({ name: "searchHighlight" })
export class SearchHighlightPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(
    value: string | undefined,
    matches: FuseResultMatch[] | undefined,
    key: string,
    search: string
  ): SafeHtml {
    if (!value) return "";
    if (Array.isArray(value)) {
      const html = value
        .map(v => {
          const tagMatch = matches?.find(m => m.key === key && m.value === v);

          return this.highlightString(v, tagMatch, search);
        })
        .join(", ");

      return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    const match = matches?.find(m => m.key === key);

    return this.sanitizer.bypassSecurityTrustHtml(this.highlightString(value, match, search));
  }

  private highlightString(text: string, match: FuseResultMatch | undefined, search: string) {
    if (!text) return "";

    if (search && text.trim().toLowerCase() === search.trim().toLowerCase()) {
      return `<mark>${text}</mark>`;
    }

    if (!match?.indices?.length) return text;

    const tokens = search?.trim().split(/\s+/).filter(Boolean) ?? [];
    const minTokenLength = tokens.length > 1 ? Math.min(...tokens.map(t => t.length)) : 0;

    const validIndices = match.indices.filter(
      ([start, end]: [number, number]) => end - start + 1 >= minTokenLength
    );

    if (!validIndices.length) {
      return text;
    }

    let result = "";
    let lastIndex = 0;

    for (const [start, end] of validIndices) {
      result += text.slice(lastIndex, start);
      result += `<mark>${text.slice(start, end + 1)}</mark>`;
      lastIndex = end + 1;
    }

    result += text.slice(lastIndex);

    return result;
  }
}
